<script setup>

import { defineProps, defineEmits} from "vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "pagamentoEletronico",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:pagamentoEletronico",
    "update:justificativa"
]);

//==================================================================//
//================ Altera Pagamento Eletronico =====================//
//==================================================================//

const alteraPagamentoEletronico = (update) =>{

    emits('update:pagamentoEletronico',update);

}

//==================================================================//
//================ Altera Pagamento Eletronico =====================//
//==================================================================//

const alteraJustificativa = (update) =>{

    emits('update:justificativa',update);

}

</script>

<template>

  <v-card
        class="c-justificativa"
    >

        <v-card-title
            class="c-justificativa__titulo"
        >
        
            <h3>Justificativa</h3>

        </v-card-title>

        <div
            class="c-justificativa__conteudo"
        >

            <v-textarea
                :value="props?.pagamentoEletronico?.justificativa"
                class="c-campo"
                label="Justificativa"
                variant="outlined"
                no-resize
                outlined
                auto-grow
                :disabled="props.controlesDesativados"
                @input="alteraJustificativa"
            >
            </v-textarea>

        </div>

    </v-card>

</template>

<style scoped>


</style>